export function queryParser(firstQuery, secondQuery) {
    secondQuery = secondQuery.replace('?', '&');
    return `${firstQuery}${secondQuery.split('&skip')[0]}`;
}
